import { Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import { AuthProvider } from "contexts/AuthContext";
import ProtectedRoute from "components/auth/ProtectedRoute";
import NotFound from "views/NotFound";
import ScrollToTop from "components/ScrollToTop";

const App = () => {
  return (
    <AuthProvider>
      <ScrollToTop />
      <Routes>
        <Route path="auth/*" element={<AuthLayout />} />
        <Route
          path="admin/*"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/admin/programs" replace />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AuthProvider>
  );
};

export default App;
